import { useMutation, useQueryClient } from '@tanstack/react-query'
import { axiosPatch } from 'Redux/axiosHelper'
import {
  LeagueStep2Payload,
  LeagueStep4Payload,
  LeagueStep7Payload,
  TravelConstraintType,
} from 'types/league/league'

const leagueRoundRobinRounds = async ({
  leagueId,
  payload,
}: {
  leagueId: string
  payload: LeagueStep2Payload
}) => {
  const response = await axiosPatch(
    payload,
    `v1/league/step-4/rounds/${leagueId}`,
  )
  return response.data
}

export const useLeagueRoundRobinRounds = () => {
  const queryClient = useQueryClient()
  return useMutation(leagueRoundRobinRounds)
}

//round robin - time slots
const leagueRoundRobinTimeSlots = async ({
  leagueId,
  payload,
}: {
  leagueId: string
  payload: LeagueStep4Payload
}) => {
  const response = await axiosPatch(
    payload,
    `v1/league/step-4/time-slots/${leagueId}`,
  )
  return response.data
}

export const useLeagueRoundRobinTimeSlots = () => {
  const queryClient = useQueryClient()
  return useMutation(leagueRoundRobinTimeSlots)
}

//round robin - games constraint
const leagueRoundRobinGameConstraint = async ({
  leagueId,
  payload,
}: {
  leagueId: string
  payload: LeagueStep7Payload
}) => {
  const response = await axiosPatch(
    payload,
    `v1/league/step-4/game-constraints/${leagueId}`,
  )
  return response.data
}

export const useLeagueRoundRobinGameConstraint = () => {
  const queryClient = useQueryClient()
  return useMutation(leagueRoundRobinGameConstraint)
}

//round robin - travel constraint
const leagueRoundRobinTravelConstraint = async ({
  leagueId,
  payload,
}: {
  leagueId: string
  payload: TravelConstraintType
}) => {
  const response = await axiosPatch(
    payload,
    `v1/league/step-4/travel-constraints/${leagueId}`,
  )
  return response.data
}

export const useLeagueRoundRobinTravelConstraint = () => {
  const queryClient = useQueryClient()
  return useMutation(leagueRoundRobinTravelConstraint)
}
